export default{
    newsTitle:"行业资讯",
    newsRead:'阅读量',

    newsTitle1:"揭秘：东南亚互联网金融风控最致命的三个痛点",
    newsContent1:'不是无法信任“风控外包”，而是这种信任的成本实在太高。',
    

    newsTitle2:'金融科技还是金融“科举”？带你一篇看完印尼最新监管细节',
    newsContent2:"印尼央行（BI）在2017年年底对外公布了针对金融科技行业（Fintech）最新的监管框架。据说是要在进一步鼓励本土的金融创新，但同时又要保护好用户的信息和金融的稳定，这矛盾怎么破？",

    newsTitle3:"大数据下的网贷风控，靠谱吗？",
    newsContent3:'现金贷和消费金融真是个大蛋糕，诱人可口，很多资本大佬也紧盯着这块市场，竞争激烈，要是没两把刷子，还真玩不转。',

    // newsTitle4:"金融科技在马来西亚达到拐点",
    // newsContent4:"毋庸置疑，2020 年是动荡的一年，疫情影响了数以百万计人的生活，但是这也为马来西亚金融科技领域的快速增长提供了动力。",

    // newsTitle5:"金融科技在拉美的机遇",
    // newsContent5:"这些年以 Nubank 为代表的拉美金融科技逐渐走进人们的视野，3300 万用户，250 亿美金估值的背后是整个拉美金融科技的爆炸式增长，也反映出银行巨头垄断下的拉美在各个金融服务领域都存在大量未被开发的机会，今天我们来探究一下拉美金融科技的前世今生。",

    newsTitle6:"2020年全球金融App下载量同比增长15%",
    newsContent6:'移动应用营销公司 Liftoff 的最新研究结果表明，全球市场中金融类应用在 2020 年表现出色，该类应用的下载总量达到了 46 亿次，同比增长 15%。',
}